import {RatingInterface} from "./interfaces/RatingInterface";

export class Rating implements RatingInterface {
    average: number | null;
    count: number | null;
    max: number | null;
    min: number | null;
    objectId: string;
    rating: number | null;
    schemaId: string;

    constructor(data: RatingInterface) {
        Object.assign(this, data);
    }

}